import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NotificationPrefsModuleState, notificationPrefsModuleKey } from './notification-prefs.reducer';
import * as fromPrefs from './notification-prefs.reducer';

const selectNotificationPrefsModuleState = createFeatureSelector<NotificationPrefsModuleState>(notificationPrefsModuleKey);

const selectNotificationPrefsState = createSelector(
  selectNotificationPrefsModuleState,
  (state: NotificationPrefsModuleState) => state?.notificationPrefs
);

export const selectError = createSelector(selectNotificationPrefsState, fromPrefs.getError);

export const selectLoginLanguages = createSelector(selectNotificationPrefsState, fromPrefs.getLoginLanguages);

export const selectLanguages = createSelector(selectNotificationPrefsState, fromPrefs.getLanguages);

export const selectShowEnterCode = createSelector(selectNotificationPrefsState, fromPrefs.getShowEnterCode);

export const selectToken = createSelector(selectNotificationPrefsState, fromPrefs.getToken);

export const selectPreferences = createSelector(selectNotificationPrefsState, fromPrefs.getPreferences);

export const selectShowRegisterEmail = createSelector(selectNotificationPrefsState, fromPrefs.getShowRegisterEmail);

export const selectEmailField = createSelector(selectNotificationPrefsState, fromPrefs.getEmailField);

export const selectShowRegisterPhone = createSelector(selectNotificationPrefsState, fromPrefs.getShowRegisterPhone);

export const selectPhoneField = createSelector(selectNotificationPrefsState, fromPrefs.getPhoneField);

export const selectShowRegisterWhatsApp = createSelector(selectNotificationPrefsState, fromPrefs.getShowRegisterWhatsApp);

export const selectWhatsAppField = createSelector(selectNotificationPrefsState, fromPrefs.getWhatsAppField);

export const selectShowLoginChoice = createSelector(selectNotificationPrefsState, fromPrefs.getShowLoginChoice);

export const selectShowLoginEmail = createSelector(selectNotificationPrefsState, fromPrefs.getShowLoginEmail);

export const selectShowLoginPhone = createSelector(selectNotificationPrefsState, fromPrefs.getShowLoginPhone);

export const selectShowOptInSmsPhone = createSelector(selectNotificationPrefsState, fromPrefs.getShowOptInSmsPhone);

export const selectShowVerifyCodeEmail = createSelector(selectNotificationPrefsState, fromPrefs.getShowVerifyCodeEmail);

export const selectShowVerifyCodePhone = createSelector(selectNotificationPrefsState, fromPrefs.getShowVerifyCodePhone);

export const selectEmail = createSelector(selectNotificationPrefsState, fromPrefs.getEmail);

export const selectPhone = createSelector(selectNotificationPrefsState, fromPrefs.getPhone);

export const selectIsLoading = createSelector(selectNotificationPrefsState, fromPrefs.getIsLoading);
